import { FormControl } from '@angular/forms';

export enum ARRAY_CONDITIONS {
  CONTAINS_ONE_OF = 'CONTAINS_ONE_OF',
  CONTAINS_ALL_OF = 'CONTAINS_ALL_OF',
  NOT_CONTAINS_ONE_OF = 'NOT_CONTAINS_ONE_OF',
  NOT_CONTAINS_ALL_OF = 'NOT_CONTAINS_ALL_OF',
}

export enum NUMBER_CONDITIONS {
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
}

export type FilterTypeValue = 'product' | 'city' | 'state' | 'age';

export interface FilterTypeItem {
  value: FilterTypeValue;
  label: string;
}

export interface Filter {
  type: FilterTypeValue;
  condition: ARRAY_CONDITIONS | NUMBER_CONDITIONS;
  values: string[];
}

export interface FilterForm {
  type: FormControl<FilterTypeValue | null>;
  condition: FormControl<ARRAY_CONDITIONS | NUMBER_CONDITIONS | null>;
  values: FormControl<string[] | string | null>;
  priority: FormControl<number | null>;
}
